import { Injectable } from '@angular/core';

import { environment as ENV } from '@environment';
import { User } from '@app/modules/core/interfaces/user';
import { CountriesVm } from '@booking/entities/countries';

@Injectable()
export class PaxFormCountryService {

  constructor() { }

  public defaultCountry(countries: CountriesVm[], user: User): string {
    const defaultCountryIndex = this.defaultCountryIndex(countries, user);
    return defaultCountryIndex > -1 ? countries[defaultCountryIndex].code : '';
  }

  private defaultCountryIndex(countries: CountriesVm[], user: User): number {
    return countries.findIndex(c => c.code === ENV.countryInfo.iso_code);
  }

}
